module.exports = __webpack_public_path__ + "static/media/muna_kaki_talking.46b702f5.gif";